<template>
  <!-- <div class="columns">
    <div class="column logbook-label">
      <p>{{ label }}</p>
    </div>
    <div class="column logbook-label">
      <p>{{ txt }}</p>
    </div>
  </div> -->
  <div>
    <p class="logbook-label">{{ label }}:</p>
    <p class="logbook-label">{{ txt }}</p>
  </div>
</template>

<script>
export default {
  props: ['label', 'txt']
}
</script>



// WEBPACK FOOTER //
// src/components/Office/LogbookItemLabel.vue